import { createAction } from '@reduxjs/toolkit';

export const CURRENT_USER_ACTION_TYPES = {
  SET_CURRENT_POLLWORKER_USER: 'SET_CURRENT_POLLWORKER_USER',
  LOGOUT_CURRENT_USER: 'LOGOUT_CURRENT_USER',
};

export const setCurrentPollworkerUser = createAction<string>(CURRENT_USER_ACTION_TYPES.SET_CURRENT_POLLWORKER_USER);
export const logoutPollworkerUser = createAction(CURRENT_USER_ACTION_TYPES.LOGOUT_CURRENT_USER);
